export const unescapeCurlyBraces = (textInput: string) =>
  textInput.replace(/\\{/g, '{').replace(/\\}/g, '}');

export const escapeCurlyBraces = (textInput: string) =>
  textInput.replace(/{/g, '\\{').replace(/}/g, '\\}');
